import { render } from "./PortalTopComponent.vue?vue&type=template&id=06ef9e56&scoped=true&ts=true"
import script from "./PortalTopComponent.vue?vue&type=script&lang=ts"
export * from "./PortalTopComponent.vue?vue&type=script&lang=ts"

import "./PortalTopComponent.vue?vue&type=style&index=0&id=06ef9e56&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06ef9e56"]])

export default __exports__